import { useMemo } from 'react';
import { CatSkeleton } from 'components/blocks-components';
import { Conditional } from '@cat-ecom/pcc-components';
import { ProductAvailabilityByDate } from 'components/product-availability';
import { InterimStoreAvailabilityType } from '../types';
import { HoseAssemblyDetails } from 'components/hose-assembly-details/hose-assembly-details';
import AvailabilityTitle from 'components/availability-wrapper/availability-title/availability-title';
import AvailabilityPickupText from 'components/availability-wrapper/availability-pickup-text';

const InterimStoreAvailablityTable = ({
  hideLabel,
  hoseAssemblyDetails,
  isLoading,
  isDeliveryEnabled,
  isPickupEnabled,
  availabilityToolTipMessage,
  sourcingDetails,
  shouldWrap,
  address,
  locale,
  hideToolTipIcon,
  availabilityByStoreLink,
  openInDrawer,
  isPccReleaseRemanReplacement = false,
  partsDiagramMobileView = false
}: InterimStoreAvailabilityType) => {
  const formattedSourcingDetails = useMemo(() => {
    if (sourcingDetails && 'availabilityBySource' in sourcingDetails) {
      return sourcingDetails.availabilityBySource?.map((detail) => ({
        ...detail,
        availStoreList: detail.availStoreList.map((store) => ({
          ...store,
          quantityAvailable: Number(store.quantityAvailable)
        }))
      }));
    } else if (Array.isArray(sourcingDetails)) {
      return sourcingDetails?.map((detail) => ({
        ...detail,
        availStoreList: detail.availStoreList.map((store) => ({
          ...store,
          quantityAvailable: Number(store.quantityAvailable)
        }))
      }));
    }
    return [];
  }, [sourcingDetails]);

  let hasData = false;
  if (sourcingDetails && 'availabilityBySource' in sourcingDetails) {
    hasData = sourcingDetails.availabilityBySource?.length > 0;
  } else if (Array.isArray(sourcingDetails)) {
    hasData = sourcingDetails?.length > 0;
  }

  const { hoseAssemblyIndicator, hoseAvailabilityLabel } =
    hoseAssemblyDetails || {};

  const renderAvailabilityTable = () => {
    return hasData ? (
      <>
        <AvailabilityTitle
          hideLabel={hideLabel}
          availabilityToolTipMessage={availabilityToolTipMessage}
          isDeliveryEnabled={isDeliveryEnabled}
          isPickupEnabled={isPickupEnabled}
          hideToolTipIcon={hideToolTipIcon}
        />
        {hoseAssemblyIndicator ? (
          <>
            <HoseAssemblyDetails
              hoseAvailabilityLabel={hoseAvailabilityLabel}
            />
            <AvailabilityPickupText
              isDeliveryEnabled={isDeliveryEnabled}
              isPickUpEnabled={isPickupEnabled}
            />
          </>
        ) : (
          <>
            <ProductAvailabilityByDate
              sourcingDetails={formattedSourcingDetails}
              isCompact={false}
              shouldWrap={shouldWrap}
              address={address}
              locale={locale}
              openInDrawer={openInDrawer}
              isPccReleaseRemanReplacement={isPccReleaseRemanReplacement}
              partsDiagramMobileView={partsDiagramMobileView}
            />
            {availabilityByStoreLink}
          </>
        )}
      </>
    ) : null;
  };

  return (
    <div data-testid="interim-store-availability-table">
      <Conditional
        test={!isLoading}
        fallback={<CatSkeleton data-testid="loader-id" width="300px" />}
      >
        {renderAvailabilityTable()}
      </Conditional>
    </div>
  );
};

export default InterimStoreAvailablityTable;
